import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SuccessIcon from '../../assets/Icons/Success.svg';

const SuccessMessage = ({ data, close }) => {
  return (
    <div>
      <div>
        <div className='h-[60px] bg-[#EFF4FF] flex items-center justify-between pl-6 pr-6 rounded-t-[20px]'>
          <div className='text-[#101828] text-sm leading-5 font-medium'>
            Success
          </div>
          <div>
            <CloseIcon
              sx={{
                height: '14px',
                width: '14px',
                color: '#415280',
                opacity: '0.8',
                cursor: 'pointer',
              }}
              onClick={close}
            />
          </div>
        </div>
        <div className='mb-11 mt-[76px]'>
          <img src={SuccessIcon} className='my-0 mx-auto' alt='' />
        </div>
        <div className='mb-11 text-center text-[#101828] font-semibold text-xl leading-6'>
          Adjusted measured angle saved Successfully
        </div>
        <div className='text-center mb-2'>
          Your new adjusted angle has been saved for{' '}
          <span className='font-bold'> {data && data.exercise_name}</span>
        </div>
        <div className='text-center mb-28 flex justify-center'>
          Their improvement opportunity now is
          <div className='flex items-center ml-2 bg-[#F0F0F0] gap-[5px] py-1 px-2'>
            <div
              className='w-[6px] h-[6px] rounded-[50%]'
              style={{
                backgroundColor:
                  data && data.interpretation_config.font_color_code,
              }}
            ></div>
            <div className='font-semibold'>
              {data && data.interpretation_config.interpretation}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;
